import { TABLER_CATEGORIES } from '../../data/data-provider';
import { rootActions, useAppDispatch, useAppSelector } from '../../data/store';
import QuestionIcon from '../icons/QuestionIcon';
import React, { useState } from 'react';
import CategoriesPopup from './CategoriesPopup';

const TablerCategories = () => {

    const dispatch = useAppDispatch();
    const category = useAppSelector(store => store.root.category) || '';

    const [popupShown, setPopupShown] = useState(false);

    const changeCategory = (newCategory: string) => {
        dispatch(
            rootActions.setCategory(newCategory),
        );

        dispatch(
            rootActions.main({
                randomizedButtonShaking: true,
            })
        );

        // scroll back to the preview
        const $preview = document.getElementById('preview');
        if(!$preview) return;

        $preview.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest'
        });

        window.setTimeout(() => {
            dispatch(
                rootActions.main({
                    randomizedButtonShaking: false,
                })
            );
        }, 6000);
    };

    const showPopup = () => {
        setPopupShown(true);
    };

    return (
        <section className="categories container mx-auto my-8 px-4 text-sm flex flex-wrap justify-center items-center">
            <label
                className={ `mr-4 bg-gray-100 rounded px-4 py-1 block mb-2 cursor-pointer ${ category === '' ? 'selected' : '' }` }
                key={ `tabler-category-radio-all` }>
                <input
                    type="radio"
                    name="tabler-category-radio"
                    className="hidden"
                    checked={ category === '' }
                    onChange={ () => {
                        changeCategory('');
                    }}
                />
                <span>All</span>
            </label>

            {
                TABLER_CATEGORIES.map(categoryName => {
                    return (
                        <label
                            className={ `mr-4 bg-gray-100 rounded px-4 py-1 block mb-2 cursor-pointer ${ category === categoryName ? 'selected' : '' }` }
                            key={ `tabler-category-radio-${ categoryName.toLowerCase() }`}>
                            <input
                                type="radio"
                                name="tabler-category-radio"
                                className="hidden"
                                checked={ category === categoryName }
                                onChange={ () => {
                                    changeCategory(categoryName);
                                }}
                            />
                            <span>{ categoryName }</span>
                        </label>
                    )
                })
            }

            <label
                className={ `mr-4 bg-gray-100 rounded px-4 py-1 block mb-2 cursor-pointer ${ category === 'no-category' ? 'selected' : '' }` }
                key={ `tabler-category-radio-without-category` }>
                <input
                    type="radio"
                    name="tabler-category-radio"
                    className="hidden"
                    checked={ category === 'no-category' }
                    onChange={ () => {
                        changeCategory('no-category');
                    }}
                />
                <span>No category</span>
            </label>

            <button
                type="button"
                className="flex items-center cursor-pointer mb-2"
                onClick={ showPopup }>
                <span className="underline mr-2 text-blue-500 text-lg">How to use</span>
                <span className="bg-green-200 text-gray-700 rounded-full block">
                    <QuestionIcon />
                </span>
            </button>

            {
                popupShown && <CategoriesPopup setPopupShown={ setPopupShown } />
            }
        </section>
    )
};

export default TablerCategories;